/**
 * Created by nijin on 28/12/16.
 */
import {Component, OnInit, Input} from '@angular/core';
import {WizardContentComponent} from "./wiz-content.component";

@Component({
  selector: 'nuc-wiz-menu',
  templateUrl: './wiz-menu.component.html',
  styleUrls:['./wiz-menu.component.scss']
})
export class WizMenu implements OnInit {

  @Input() wizSteps: Array<WizardContentComponent>;
  @Input() activeStep;
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/things/shared/wizard/wiz-menu.component.ts